import React from 'react'
import { Button, notification } from 'antd'
import { Route } from 'react-router-dom'

import { ItemList } from '~components'
import { getCurrentUser } from '~context'
import { PageLayout } from '~stories'

const NOTIFICATION_MESSAGES = {
  UNAUTHORIZED: 'You are not authorized to perform this action.'
}
const PAGE_TITLE = 'Flags'

const getFlagsNameWithLink = flag => <a href={`flags/${flag._id}/edit`}>{String(flag?.title).toUpperCase()}</a>

const getFlagsDescriptionAsHTML = flag => <div dangerouslySetInnerHTML={{ __html: flag?.html_description }}/>

const getFlagsColor = flag => <span>{flag?.color?.value}</span>

const columnData = [
  {
    dataIndex: 'title',
    render: (text, flag) => getFlagsNameWithLink(flag),
    sorter: true,
    title: 'Title',
    width: '30%',
    sortDirections: ['descend', 'ascend', 'descend']
  },
  {
    title: 'Description',
    width: '40%',
    render: flag => getFlagsDescriptionAsHTML(flag)
  },
  {
    title: 'Color',
    width: '15%',
    render: flag => getFlagsColor(flag)
  },
  {
    dataIndex: 'app_name',
    title: 'App',
    width: '30%'
  }
]

const addNewFlag = isContentEditor => {
  return (
    <Route render={({ history }) => (
      <Button
        key="1"
        onClick={() => {
          isContentEditor
            ? history.push('/flags/new')
            : notification.error({ message: NOTIFICATION_MESSAGES.UNAUTHORIZED })
        }}
        type="primary"
      >
        Add Flag
      </Button>
    )} />
  )
}

const Flags = () => {
  const { userDetails: { isContentEditor } } = getCurrentUser()

  return (
    <PageLayout extra={[
      addNewFlag(isContentEditor)
    ]} title={PAGE_TITLE}>
      <div className="sponsors-layout-background">
        <ItemList columns={columnData} resource='flags' />
      </div>
    </PageLayout>
  )
}

export default Flags
